<div class="flex flex-col gap-y-4">
	<!-- Indicateur de progression -->
	<!-- <div class="flex items-center justify-center mb-4">
		<div class="flex items-center space-x-2">
			<div class="flex items-center">
				<div class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium"
					[class]="currentStep >= 1 ? 'bg-primary text-white' : 'bg-gray-200 text-gray-500'">
					1
				</div>
				<div class="w-12 h-1 mx-2" [class]="currentStep >= 2 ? 'bg-primary' : 'bg-gray-200'"></div>
			</div>
			<div class="flex items-center">
				<div class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium"
					[class]="currentStep >= 2 ? 'bg-primary text-white' : 'bg-gray-200 text-gray-500'">
					2
				</div>
				<div class="w-12 h-1 mx-2" [class]="currentStep >= 3 ? 'bg-primary' : 'bg-gray-200'"></div>
			</div>
			<div class="flex items-center">
				<div class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium"
					[class]="currentStep >= 3 ? 'bg-primary text-white' : 'bg-gray-200 text-gray-500'">
					3
				</div>
			</div>
		</div>
	</div> -->

	<!-- Étape 1: Demande d'OTP -->
	<div *ngIf="currentStep === 1">
		<p class="text-sm text-gray-600 mb-4">
			Renseignez votre numéro de téléphone pour recevoir un code de vérification.
		</p>

		<form [formGroup]="step1Form" (ngSubmit)="onStep1Submit()" class="w-full flex flex-col items-center gap-3">
			<angular-phone-number-input [preferredCountries]="preferredCountries" [defaultCountry]="'SN'" [border]="true"
				formControlName="phoneNumber" (phoneNumberChange)="onPhoneNumberChange($event)"
				class="w-full h-[45px] rounded placeholder:text-gray-500 text-gray-700 bg-white"
				[ariaPlaceholder]="'Numéro de téléphone'" placeholder="Numéro de téléphone">
			</angular-phone-number-input>

			<div *ngIf="step1PhoneNumberError" class="text-red-500 text-xs mt-1 ml-2 w-full">
				{{ step1PhoneNumberError }}
			</div>

			<div class="flex items-center gap-x-2 py-2 justify-end w-full">
				<button type="button" (click)="closeModal()" class="text-gray-400 text-xs">Annuler</button>
				<button type="submit" [disabled]="isLoading"
					class="bg-primary text-white px-4 py-2 rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
					<span *ngIf="!isLoading">Envoyer le code</span>
					<span *ngIf="isLoading" class="flex items-center justify-center">
						<lucide-icon [img]="Loader2Icon" class="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
							[size]="16"></lucide-icon>
						Envoi en cours...
					</span>
				</button>
			</div>
		</form>
	</div>

	<!-- Étape 2: Vérification OTP -->
	<div *ngIf="currentStep === 2">
		<p class="text-sm text-gray-600 mb-4">
			Entrez le code de vérification envoyé à votre numéro de téléphone.
		</p>

		<form [formGroup]="step2Form" (ngSubmit)="onStep2Submit()" class="w-full flex flex-col items-center gap-3">
			<div class="w-full">
				<input type="text" formControlName="otpCode"
					class="w-full h-[45px] px-3 rounded border border-gray-300 placeholder:text-gray-500 text-gray-700 bg-white text-center text-lg tracking-widest"
					placeholder="000000" maxlength="6" pattern="[0-9]*" inputmode="numeric">
				<div *ngIf="step2OtpError" class="text-red-500 text-xs mt-1 ml-2">
					{{ step2OtpError }}
				</div>
			</div>

			<div class="flex items-center gap-x-2 py-2 justify-between w-full">
				<button type="button" (click)="goBack()" class="text-gray-400 text-xs">Retour</button>
				<button type="submit" [disabled]="isLoading"
					class="bg-primary text-white px-4 py-2 rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
					<span *ngIf="!isLoading">Vérifier le code</span>
					<span *ngIf="isLoading" class="flex items-center justify-center">
						<lucide-icon [img]="Loader2Icon" class="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
							[size]="16"></lucide-icon>
						Vérification...
					</span>
				</button>
			</div>
		</form>
	</div>

	<!-- Étape 3: Nouveau mot de passe -->
	<div *ngIf="currentStep === 3">
		<p class="text-sm text-gray-600 mb-4">
			Choisissez un nouveau mot de passe sécurisé.
		</p>

		<form [formGroup]="step3Form" (ngSubmit)="onStep3Submit()" class="w-full flex flex-col items-center gap-3">
			<div class="w-full">
				<div
					class="form-group auth-form-group-custom w-full rounded text-gray-700 overflow-hidden border border-solid border-gray-300 relative">
					<lucide-icon [img]="LockIcon" class="auti-custom-input-icon text-primary" [size]="24"></lucide-icon>
					<label class="text-sm" for="newPassword">Nouveau mot de passe</label>
					<input [type]="showPassword ? 'text' : 'password'" formControlName="newPassword"
						class="form-control w-full placeholder:text-sm placeholder:text-gray-400" id="newPassword"
						placeholder="Nouveau mot de passe" />

					<button type="button" (click)="togglePasswordVisibility()"
						class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
						<lucide-icon [img]="showPassword ? EyeOffIcon : EyeIcon" [size]="24"></lucide-icon>
					</button>
				</div>
				<div *ngIf="step3NewPasswordError" class="text-red-500 text-xs mt-1 ml-2">
					{{ step3NewPasswordError }}
				</div>
			</div>

			<div class="w-full">
				<div
					class="form-group auth-form-group-custom w-full rounded text-gray-700 overflow-hidden border border-solid border-gray-300 relative">
					<lucide-icon [img]="LockIcon" class="auti-custom-input-icon text-primary" [size]="24"></lucide-icon>
					<label class="text-sm" for="confirmPassword">Confirmer le mot de passe</label>
					<input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
						class="form-control w-full placeholder:text-sm placeholder:text-gray-400" id="confirmPassword"
						placeholder="Confirmer le mot de passe" />

					<button type="button" (click)="toggleConfirmPasswordVisibility()"
						class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
						<lucide-icon [img]="showConfirmPassword ? EyeOffIcon : EyeIcon" [size]="24"></lucide-icon>
					</button>
				</div>
				<div *ngIf="step3ConfirmPasswordError" class="text-red-500 text-xs mt-1 ml-2">
					{{ step3ConfirmPasswordError }}
				</div>
				<div *ngIf="passwordsMatchError" class="text-red-500 text-xs mt-1 ml-2">
					{{ passwordsMatchError }}
				</div>
			</div>

			<div class="flex items-center gap-x-2 py-2 justify-between w-full">
				<button type="button" (click)="goBack()" class="text-gray-400 text-xs">Retour</button>
				<button type="submit" [disabled]="isLoading"
					class="bg-primary text-white px-4 py-2 rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
					<span *ngIf="!isLoading">Changer le mot de passe</span>
					<span *ngIf="isLoading" class="flex items-center justify-center">
						<lucide-icon [img]="Loader2Icon" class="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
							[size]="16"></lucide-icon>
						Modification...
					</span>
				</button>
			</div>
		</form>
	</div>
</div>